<template>
<div class="w100" @click="handleClickOutside">
  <headerSearch></headerSearch>
  <div class="w1440 personal_center">
    <div class="flex-box col90 ptb10 page_location">
      当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
      <router-link class="col04" to="/BaseInfo">我的账户<span class="plr5">/</span></router-link>
      <div class="now_page">会员中心</div>
    </div>
    <div class="flex-box flex-col-start">
      <personal-nav :firstIndex="0" :secondIndex="1"></personal-nav>
      <div class="ml10 flex-grow-1 part_r">
        <div class="top_box">
          <div class="company_box flex-box">
            <img :src="userinfo.group_model.avatar" class="company_img" alt="" />
            <div class="company_name fs28 fwb">
              {{userinfo.group_model.company_name}}
            </div>
            <i :class="'vip'+vip_id"></i>
          </div>
          <div class="level_box flex-box">
            <div v-for="(vip,index) in vipList" :key="index" class="flex-grow-1 flex-box flex-col-start level_item" :class="['level'+vip.level,{'active' :vip_id >= vip.level}]">
              <div>
                <div class="fs16 col04 mt10 mb10">{{vip.name}}</div>
                <div class="fs14 mb15" :class="vip_id >= 1 ? 'col12' : 'col90'">
                  {{ vip_id >= vip.level ? "已解锁" : "未解锁" }}
                </div>
                <!-- <div class="flex-box" v-if="vip_level >= vip.level">
                  <div class="point_box">
                    <div :style="`width:${point}%`"></div>
                  </div>
                  <div class="fs10 col27">{{ point }}/100</div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div v-if="vip_id" class="bottom_box">
          <div class="flex-box flex-between mb30">
            <div class="fs16 col04">
              我的等级权益<span class="col12">（V{{vip_level}}）</span>
            </div>
            <div class="flex-box intro fs16 col90" ref="tips">
              等级权益说明
              <div class="tips fs14" :class="showIntro ? 'show' : ''">
                白银会员共分为三级：V1(0-100)、V2(100-200)、V3(200-300)，当前阶段V{{ vip_level }}。
              </div>
            </div>
          </div>
					<div v-html="privilege" class="label_box">
					</div>
          <!-- <div class="label_box">
            <div class="flex-box title_box fs18 col04">
              <div class="title1"></div>
              <div class="title2">权益</div>
              <div class="title3 pl15">详细内容</div>
            </div>
            <div class="flex-box quality_box fs18 col04" v-for="(item, index) in 10" :key="index">
              <div class="quality1">
                <img src="../../../assets/static/icon/c_quality.png" class="quality" alt="" v-if="vip_level < index" />
                <img src="../../../assets/static/icon/c_quality-on.png" class="quality" alt="" v-else />
              </div>
              <div class="quality2 pl5">权益一</div>
              <div class="quality3">
                详细内容详细内容详细内容详细内容详细内容详细内容详细内容详细内容详细内容详细内容详细内容详细内容详细内容详细内容详细内容详细内容详细内容
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "会员中心-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
  components: {
    PersonalNav,
  },
  data() {
    return {
      vip_level: 0,
      vip_id: 0,
      point: 55,
      showIntro: false,
			userinfo:{
        group_model:{
          avatar:'',
          company_name:''
        }
      },
			vipList:[],
    };
  },
	computed:{
		privilege(){
			return this.vip_id ? this.vipList[this.vip_id-1].privilege : ''
		},
		islogin() {
      return this.$h.islogin()
    }
	},
  created() {
    if (!this.islogin) {
      this.$router.push('/Login')
    } else {
      this.getUserInfo()
    }
  },
  methods: {
		// 获取用户信息
    getUserInfo() {
      let that = this;
      that.$api.GetUserInfo().then(res => {
        if (res.code == 1) {
          that.userinfo = res.data
					that.vip_level=res.data.institution.level
					that.vip_id=res.data.institution.vip_id
        }
      })
      that.$api.Vip().then(res => {
        if (res.code == 1) {
					that.vipList = res.data
        }
      })
    },
    handleClickOutside(event) {
      const tips = this.$refs.tips;
      // 检查点击的目标是否在提示框内
      if (tips && tips.contains(event.target)) {
        this.showIntro = !this.showIntro;
      } else {
        this.showIntro = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.w100 {
  width: 100vw;
}

.part_r {
  .top_box {
    width: 100%;
    background: #fff;

    .company_box {
      height: 214px;
      border-bottom: 0.6px solid rgba(98, 134, 171, 0.4);
      padding-left: 52px;

      .company_img {
        width: 100px;
        height: 100px;
        display: block;
        margin-right: 20px;
        border-radius: 50%;
        object-fit: cover;
      }

      .company_name {
        color: #272727;
        letter-spacing: 1.2px;
      }

      i {
        width: 135px;
        height: 60px;
        display: block;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;

        &.vip1 {
          background-image: url("/src/assets/static/icon/c_vip1.png");
        }

        &.vip2 {
          background-image: url("/src/assets/static/icon/c_vip2.png");
        }

        &.vip3 {
          background-image: url("/src/assets/static/icon/c_vip3.png");
        }
      }
    }

    .level_box {
      padding: 28px 0 20px;

      .level_item {
        padding-left: 38px;

        &::before {
          content: "";
          display: block;
          width: 120.5px;
          height: 120.5px;
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100%;
          margin-right: 22px;
        }

        &.level1::before {
          background-image: url("/src/assets/static/icon/c_level3.png");
        }

        &.level2::before {
          background-image: url("/src/assets/static/icon/c_level2.png");
        }

        &.level3::before {
          background-image: url("/src/assets/static/icon/c_level3.png");
        }

        &.level1.active::before {
          background-image: url("/src/assets/static/icon/c_level1-on.png");
        }

        &.level2.active::before {
          background-image: url("/src/assets/static/icon/c_level2-on.png");
        }

        &.level3.active::before {
          background-image: url("/src/assets/static/icon/c_level3-on.png");
        }

        .point_box {
          width: 93.33px;
          height: 8px;
          border-radius: 6px;
          background: #1275ff;
          margin-right: 8px;

          div {
            height: 8px;
            border-radius: 6px;
            background: linear-gradient(180deg, #f1f7ff 0%, #b6d1f7 100%);
          }
        }
      }
    }
  }

  .bottom_box {
    margin-top: 14px;
    padding: 40px 44px;
    background: #fff;

    .intro {
      cursor: pointer;
      position: relative;

      &::before {
        content: "";
        display: block;
        width: 18px;
        height: 18px;
        background: url("/src/assets/static/icon/c_intro.png") no-repeat center;
        background-size: 100%;
        margin-right: 6px;
      }

      .tips {
        display: none;
        background: rgba(0, 0, 0, 0.6);
        padding: 12px 15px;
        border-radius: 5px;
        color: #fff;
        width: 280px;
        word-break: break-word;
        position: absolute;
        top: 40px;
        right: 0;

        &::before {
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-width: 11px;
          border-style: solid;
          border-color: transparent transparent rgba(0, 0, 0, 0.6);
          position: absolute;
          top: -20px;
          right: 50px;
        }

        &.show {
          display: block;
        }
      }
    }

    .title_box {
      width: 1000px;
      height: 50px;
      background: rgba(18, 117, 255, 0.1);

      .title1 {
        width: 220px;
      }

      .title2 {
        width: 186px;
      }

      .title3 {
        flex: 1;
      }
    }

    .quality_box {
      padding: 33px 0;
      width: 1000px;
      background: #fafcff;

      .quality1 {
        width: 220px;

        .quality {
          width: 90px;
          height: 90px;
          display: block;
          margin-left: 50px;
        }
      }

      .quality2 {
        width: 186px;
      }

      .quality3 {
        flex: 1;
      }

      &:nth-of-type(2n) {
        background: #fff;
      }
    }
  }
}
</style>
